import React from 'react';
import PropTypes from 'prop-types';
import { Controller, useFormContext } from "react-hook-form";
import ErrorMessage from './ErrorMessage';
import RichEditor from '../RichEditor';
import { createEditorStateWithContent, createEditorSaveContent} from '../RichEditor/editorUtils';


const RichTextInput = ({name, placeholder, containerStyle, hideExternalPlugins=true}) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({
        field, //{ onChange, onBlur, value, name, ref }
        fieldState: { invalid, isTouched, isDirty, error },
        formState,
      }) => (
        <div className="form-group mb-3" style={containerStyle}>
          <RichEditor
            className={`form-control rounded-0 ${isTouched && invalid ? "is-invalid" : ""}`}
            editorState = { field.value }
            onChange={ field.onChange }
            onBlur={ field.onBlur }
            placeholder = { placeholder }
            hideExternalPlugins={hideExternalPlugins}
          />
          <ErrorMessage error={error}/>
        </div>
      )}
    />
  )
}

RichTextInput.defaultProps = {};

RichTextInput.propTypes = {
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string
};

RichTextInput.createState = createEditorStateWithContent;

RichTextInput.contentForSave = createEditorSaveContent;

export default RichTextInput;